<template>
    <loader v-if="loading" />
    <div v-else>
        <v-row>
            <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards" :key="index">
                <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
            </v-col>
        </v-row>
        <v-card>
            <v-tabs v-model="tabIndex">
                <v-tab value="campaigns">Kampagner / Agenturer</v-tab>
                <v-tab value="agents">Agenturer / Kampagner</v-tab>
            </v-tabs>
            <sales-pivot
                v-if="tab === 'kampagner'"
                defaultSort="avgLead"
                :dataObject="campaignStats"
                :fields="$store.state.main.standardSalesPivotOptions.fields"
                :nestedFields="$store.state.main.standardSalesPivotOptions.nestedFields"
                :valueFunctions="$store.state.main.standardSalesPivotOptions.valueFunctions" />
            <sales-pivot
                v-else-if="tab === 'agenturer'"
                defaultSort="avgLead"
                :dataObject="agentStats"
                :fields="$store.state.main.standardSalesPivotOptions.fields"
                :nestedFields="$store.state.main.standardSalesPivotOptions.nestedFields"
                :valueFunctions="$store.state.main.standardSalesPivotOptions.valueFunctions" />
        </v-card>
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'
import TotalCard from '@/components/totalCard'

export default {
    components: {
        SalesPivot,
        TotalCard
    },
    data () {
        return {
            campaignStats: null,
            agentStats: null,
            uploadedStats: null,
            uploaded: [],
            tabIndex: 0,
            tabs: ['kampagner', 'agenturer'],
            loading: true,
            totalCards: [
                {
                    header: 'Afsluttede',
                    formatter: this.$options.filters.separator,
                    value: v => v.count
                },
                {
                    header: 'Gns. præmie',
                    formatter: this.$options.filters.separator,
                    value: v => v.sales ? v.total / v.sales : v.total
                },
                {
                    header: 'Salg pr. emne',
                    formatter: this.$options.filters.separator,
                    value: v => v.count ? v.total / v.count : v.total
                },
                {
                    header: 'Solgt præmie',
                    formatter: this.$options.filters.separator,
                    value: v => v.total
                }
            ]
        }
    },
    computed: {
        tab () {
            return this.tabs[this.tabIndex]
        },
        period () {
          return this.$store.state.reports.period  
        },
        range () {
            return this.$store.state.reports.range
        },
        totals() {
            return this.$reduceNested(this.agentStats, ['count', 'total', 'sales'])
        },
        report () {
            return this.$store.getters['reports/currentReport']
        },
        groupIndex () {
            return this.$store.state.reports.groupIndex
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().post('/reports/stats', {
                from: this.range[0],
                to: this.range[1],
                campaigns: this.$store.getters['reports/campaigns']
            })
            this.campaignStats = response.data.campaignStats
            this.agentStats = response.data.agentStats
            this.loading = false
        }
    },
    watch: {
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        report: function () {
            this.getData()
        },
        groupIndex: function () {
            this.getData()
        }
    },
    async created () {
        this.getData()
    }
}
</script>